import React from "react";
import heroImg from "../assets/90 day guarantee.png";

const NinetyDaysDayWarranty = () => {
  return (
    <div>
      {/* HERO SECTION */}
      <section className="relative w-full h-[60vh] md:h-[80vh] flex items-end text-white overflow-hidden">
        {/* Background image */}
        <img
          src={heroImg}
          alt="Hero background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* FULL OVERLAY tint instead of gradient */}
        <div
          className="absolute inset-0 z-10"
          style={{
            background:
              "linear-gradient(rgba(31, 41, 84, 0.5) 10%, rgba(239, 81, 75, 0.6) 77%)",
          }}
        />

        {/* Text content */}
        <div className="relative z-20 p-6 md:p-20">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Free 90-day warranty
          </h1>
          <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold">
            So you can relax and enjoy your new car.
          </p>
        </div>
      </section>

      {/* Extra peace of mind */}
      <section className="max-w-2xl mx-auto py-10">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold text-center mb-5">
          Extra peace of mind
        </h1>
        <p className="text-base md:text-lg lg:text-xl text-center text-primary font-medium">
          Keep cinching it with a free 90-day warranty automatically applied to
          your new ride.
        </p>
      </section>

      {/* Browse Buy and Relax */}
      <section className="bg-white py-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Right: Text Content */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              Browse, buy and relax
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              When you buy a car with us, you'll receive a free 90-day warranty
              and it's valid from the moment your car is delivered or collected.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              We’ve got you covered with over 6000 garages that can handle
              mechanical or electrical repairs, wherever you are.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              And you can opt out by calling our customer experience team at any
              point during the 90 days.
            </p>
          </div>

          {/* Left: Image */}
          <div>
            <img
              //   src={qs1}
              src="https://images.unsplash.com/photo-1623682784866-6644395e42b4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>
        </div>
      </section>

      {/* What's covered? */}
      <section className="bg-white pb-10 px-4 rounded-tl-3xl relative">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 ">
          {/* Right: Image */}
          <div>
            <img
              //   src={qs2}
              src="https://images.unsplash.com/photo-1700727448575-6f1680cd7d75?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cXVhbGl0eSUyMGNoZWNrfGVufDB8fDB8fHww"
              alt="What drives us"
              className="w-full h-full rounded-3xl object-cover"
            />
          </div>

          {/* Left: Text */}
          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-5">
              What's covered?
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              Your free 90-day warranty covers mechanical and electrical
              components, excluding normal wear and tear and accidental damage.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              You might even be eligible for a hire car, depending on the repair
              needed. Nice one!
            </p>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              And you’ll get free breakdown assistance from the RAC to get you
              back on the road in an emergency.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-4">
              Find out exactly what’s covered and details of the policy
              exclusions here.
            </p>
          </div>
        </div>
      </section>

      {/* What happens when you claim? */}
      <section className="max-w-5xl mx-auto py-10 px-4">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-accent font-bold mb-4">
          What happens when you claim?
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-primary font-medium mb-12">
          Firstly call the number above and explain the fault, then we can kick
          off the process of getting you back on the road.
        </p>

        <div className="relative pl-8">
          {/* Vertical line */}
          <div className="absolute left-11 z-0 top-1 bottom-20 w-0.5 bg-gray-200" />

          {/* Steps */}
          <div className="space-y-12 max-w-2xl">
            {/* Step 1 */}
            <div className="flex items-start">
              <div className="z-10 flex-shrink-0 mt-1">
                <div className="h-6 w-6 bg-primary rounded-full" />
              </div>
              <div className="ml-6">
                <h3 className="text-base md:text-lg lg:text-xl font-bold text-accent mb-2">
                  Step 1
                </h3>
                <p className="text-base md:text-lg lg:text-xl text-primary font-medium">
                  We review the information, share it with one of the garages in
                  our network and get your car booked in to be looked at.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start">
              <div className="z-10 flex-shrink-0 mt-1">
                <div className="h-6 w-6 bg-primary rounded-full" />
              </div>
              <div className="ml-6">
                <h3 className="text-base md:text-lg lg:text-xl font-bold text-accent mb-2">
                  Step 2
                </h3>
                <p className="text-base md:text-lg lg:text-xl text-primary font-medium">
                  The garage will run diagnostics and share the findings with us
                  to check it’s covered under warranty. Once authorised, the
                  garage will start the repair work.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start">
              <div className="z-10 flex-shrink-0 mt-1">
                <div className="h-6 w-6 bg-primary rounded-full" />
              </div>
              <div className="ml-6">
                <h3 className="text-base md:text-lg lg:text-xl font-bold text-accent mb-2">
                  Step 3
                </h3>
                <p className="text-base md:text-lg lg:text-xl text-primary font-medium">
                  We receive the repair report and finalise everything on our
                  side—then you’re good to go!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NinetyDaysDayWarranty;
